/**
 * DI seam for the "Persone" + "Struttura" UI. Host (apps/web) configures
 * at boot; UI routes read via getter. Mirrors assistant / shifts singletons.
 */
export interface UsersApiClient {
  readonly apiBase: string;
  readonly getAuthToken: () => Promise<string>;
}

let current: UsersApiClient = {
  apiBase: "",
  getAuthToken: async () => {
    throw new Error(
      "UsersApiClient.getAuthToken: not configured — host must call setUsersApi() at boot",
    );
  },
};

export function setUsersApi(client: UsersApiClient): void {
  current = client;
}

export function getUsersApi(): UsersApiClient {
  return current;
}

export function __resetUsersApi(): void {
  current = {
    apiBase: "",
    getAuthToken: async () => {
      throw new Error("not configured");
    },
  };
}
